import { get } from "../methods";
var getDashboardInternationalMarkets_default = (headers = {}) => {
  return get({
    url: "dashboard/international-markets",
    headers
  });
};
export {
  getDashboardInternationalMarkets_default as default
};
